<script setup lang="ts">
import { $t } from '@/composables/translations/useTranslate.ts';
</script>

<template>
  <div class="bg-white border-highlight-1 border rounded-xl p-7.5 animate-pulse" aria-hidden="true">
    <span class="sr-only">{{ $t('ibe.common.loading', 'Loading...') }}</span>
    <div class="flex flex-col lg:flex-row">
      <div class="flex-1">
        <div class="h-6 bg-actions-tertiary rounded w-1/2 mb-2.5"></div>
        <div class="space-y-2 mb-5">
          <div class="h-4 bg-actions-tertiary rounded w-full"></div>
          <div class="h-4 bg-actions-tertiary rounded w-3/4"></div>
        </div>
      </div>

      <div class="flex flex-col items-start lg:items-end gap-2.5 lg:w-1/3 lg:ml-5">
        <div class="flex gap-1.5 items-center">
          <div class="w-2.5 h-2.5 rounded-full bg-actions-tertiary"></div>
          <div class="h-4 bg-actions-tertiary rounded w-20"></div>
        </div>

        <div class="h-8 bg-actions-tertiary rounded w-32"></div>
        <div class="h-12 bg-actions-tertiary rounded w-full lg:w-40 mt-2.5"></div>
      </div>
    </div>
  </div>
</template>
